import { NavigateFunction } from 'react-router-dom';



export function closePage(navigate: NavigateFunction, path?: string) {
    navigate(path ?? "/", {replace: true});
    // if (history.location.pathname === '/') {
        
    // } else if (history.location.state) {
    //     history.go(-1);
    // } else {
    //     history.replace("/")
    // }
}

export function navPath(path: string, pathName: string) {
    return { pathname: path, state: {parent: pathName}}
}
